import { AddNewNodeIcon, CenterIcon, DeleteIcon, ColorPickerIcon, UndoIcon, RedoIcon, HomeIcon, ExportIcon, SaveIcon, LoadIcon, ShareIcon, SearchIcon } from './icons';

const Menu = ({
  handleAddChildNode,
  centerNode,
  handleRemoveNode,
  handleUndo = () => {},
  handleRedo = () => {},
  setShowPicker,
  toggleDarkMode,
  showPicker,
  selectedId,
  isDarkMode,
  canUndo = () => false,
  canRedo = () => false,
  showHome,
  onHome,
  onExport,
  onExportData,
  onImportData,
  onShare,
  onSearch,
  canWrite = true,
}) => {

    const buttonStyle = {
        background: 'transparent',
        border: 'none',
        padding: 2,
        marginBottom: 30,

        cursor: 'pointer',
        outline: 'none',
        color: isDarkMode ? '#fff' : '#000',
        fontSize: 19,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
    return (
        <div
          style={{
            backgroundColor: isDarkMode
              ? 'rgba(45, 45, 45, 0.7)'
              : 'rgba(255, 255, 255, 0.7)',
            borderRadius: 15,
            padding: 10,
          }}
          onClick={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
          onPointerUp={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
        >
        <button
          onClick={toggleDarkMode}
          style={{...buttonStyle, fontSize: 18, marginTop:20}}
        >
          {isDarkMode ? '☀️' : '🌙'}
        </button>
        {showHome && onHome && (
          <button onClick={onHome} style={buttonStyle}>
            <HomeIcon />
          </button>
        )}
        {onSearch && (
          <button onClick={onSearch} style={buttonStyle} title="Search map (Ctrl/Cmd+F)" aria-label="Search map">
            <SearchIcon />
          </button>
        )}
        <button disabled={!canWrite} onClick={handleAddChildNode} style={buttonStyle} title="Add child (Tab)"><AddNewNodeIcon/></button>
        <button onClick={() => centerNode(selectedId)} style={buttonStyle}><CenterIcon/></button>
        <button disabled={!canWrite} onClick={handleRemoveNode} style={buttonStyle}><DeleteIcon/></button>
        <button
          onClick={handleUndo}
          disabled={!canWrite || !canUndo()}
          style={buttonStyle}
          title="Undo (Ctrl/Cmd+Z)"
          aria-label="Undo"
        >
          <UndoIcon />
        </button>
        <button
          onClick={handleRedo}
          disabled={!canWrite || !canRedo()}
          style={buttonStyle}
          title="Redo (Ctrl/Cmd+Shift+Z)"
          aria-label="Redo"
        >
          <RedoIcon />
        </button>
        <button disabled={!canWrite} onClick={() => setShowPicker(!showPicker)} style={buttonStyle}><ColorPickerIcon /></button>
        {onExport && (
          <button onClick={onExport} style={buttonStyle} title="Export as PNG image">
            <ExportIcon />
          </button>
        )}
        {onShare && (
          <button
            onClick={onShare}
            style={buttonStyle}
            title="Share map"
            aria-label="Share map"
          >
            <ShareIcon />
          </button>
        )}
        {onExportData && (
          <button onClick={onExportData} style={buttonStyle} title="Export map as JSON">
            <SaveIcon />
          </button>
        )}
        {canWrite && onImportData && (
          <button onClick={onImportData} style={buttonStyle} title="Import map from file">
            <LoadIcon />
          </button>
        )}

        </div>
        )

}

export default Menu;
